import * as React from 'react';
import configData from "../../../config.json";

import { RouteComponentProps } from 'react-router';
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Button, FormText, Input, Label } from 'reactstrap';
import Table from 'react-bootstrap/Table'

import { alertService } from 'components/Varios/alert_service.js';
import InputFileUpload from "components/Varios/InputFileUpload.js";
import InputFileDownload from "components/Varios/InputFileDownload.js";
import ModalPDF from "components/Varios/ModalPDF.js";
import ModalDetailDocumento from "components/Varios/ModalDetailDocumento.js";
import Datepicker from 'components/Varios/Datepicker';
import DownloadIcon from 'components/Varios/DownloadIcon';
import Informacion from 'components/Varios/Informacion';
import ModalMensaje from 'components/Varios/Modals/ModalMensaje';
import ModalSubirDocumentoFirmado, { ObjetoSubirDocumento } from 'components/Varios/Modals/ModalSubirDocumentoFirmado';
import ModalIngresarObservacion from 'components/Varios/Modals/ModalIngresarObservacion';

import { authenticationService } from '../../../services/authentication.service';

import { GetTodayDateDifferenceForDatePicker, GetTodayDateForDatePicker } from 'helpers/DateFunctions';
import { hadleAxiosError, hadleAxiosErrorResponse } from 'helpers/handle-response';
import { authHeader } from 'helpers/auth-header';

import axios from 'axios';
import { classNameDownloadPdf, classNameIconoMessage } from 'constants/Icons-Font-Awesome';
import "assets/scss/DocumentosEntregar.scss"
import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import InfoSVG from "assets/icons/Permisos/InfoBlue.svg"


//ICONOS SVG
import { ReactComponent as Aviso } from 'assets/icons/ParaSUconocimiento.svg';
import { authHeaderWithToken } from "helpers/auth-header";
import { EstadoRevisionTH } from '../../../Types/GeneralTypes';
import { formatoFecha } from '../../Admin/Inicio-Admin/Dashboard_Individual_Admin';

const API_URL = configData.SERVER_URL

const AVISO_ENTRADA = "AE"

var MAP_DOCUMENT_NAME = {
    "1": AVISO_ENTRADA,    
}
export class AvisoEntradaData {
    idotrosdocumentos: number = 0
    idpersona: number = 0;
    idusuarioultodc?: number | null = 0;    //id de la persona de financiero
    refarchivo2: string = "";    //documento sin firmar
    refdoc3: string = "";   //documento con firma del servidor
    refdoc: string = "";  //documento con ambas firmas (servidor y finanza)
    estadorevisionth: number = 0;       
    estado: string = "";
    fechaDocumento: string | Date = "";    
}

type ModalDocumentoState = {
    show: boolean,
    siglasDocumento: string,    
}
interface DocumentosEntregarState {
    currentUser: any,
    loading: boolean;
    isOpenModal: boolean;
    urlPDF: any,
    disableBtn: boolean;
    avisoEntradaData: AvisoEntradaData;
    filesData: Array<any>;
    showModalDocumentoAvisoEntrada: boolean,
    mensajeInformacion?: React.ReactElement
    modalNotificarInconveniente: ModalDocumentoState
}

type ExtraInfoAvisoEntrada = {
    refdocumentoBase: string;
    refdocumentoAEFirmaServidor: string;
    refdocumentoAEFirmaTotal: string;
    idPersonaFinancieroFirma: number | null;
}

type PostNotificarInconvenienteDTO = {
    idOtrosDocumentos: number,
    tipoDocumento: string,
    descripcion: string
}
export function ParseEstadosDocumentosTH(estadoTh: number | undefined | null, extraInfo?: ExtraInfoAvisoEntrada) {

    if (extraInfo !== undefined) {

        const { refdocumentoBase, refdocumentoAEFirmaServidor, refdocumentoAEFirmaTotal, idPersonaFinancieroFirma } = extraInfo;

        const personaFinancieroFirma = idPersonaFinancieroFirma !== undefined && idPersonaFinancieroFirma !== null && idPersonaFinancieroFirma > 0;

        if (estadoTh === EstadoRevisionTH.NEGADO) {
            return "Negado"
        }
        else if (estadoTh === EstadoRevisionTH.NOTIFICADO_SERVIDOR) {
            return "Notificado/Negado por servidor";
        }
        else if (estadoTh === EstadoRevisionTH.NOTIFICADO_GERENCIA_FINANCIERA) {
            return "Notificado por Gerencia Financiera";
        }
        else if (refdocumentoAEFirmaTotal !== undefined && refdocumentoAEFirmaTotal !== null && estadoTh === EstadoRevisionTH.APROBADO) {
            return "Registrado por T.H."
        }
        else if ((refdocumentoBase !== undefined && refdocumentoBase !== null) && (refdocumentoAEFirmaServidor === undefined || refdocumentoAEFirmaServidor === null)) {
            return "Emitido por T.H"
        }
        else if (refdocumentoAEFirmaTotal !== undefined && refdocumentoAEFirmaTotal !== null && estadoTh === EstadoRevisionTH.ENVIADO_GERENCIA_FINANCIERA && personaFinancieroFirma) {
            return "Firmado por Gerencia Financiera"
        }
        else if (refdocumentoAEFirmaServidor !== undefined && refdocumentoAEFirmaServidor !== null) {
            return "Firmado por el servidor"
        }
    }

    switch (estadoTh) {
        case 0:
            return "Pendiente";

        case undefined:
            return "Pendiente";

        case null:
            return "Pendiente";

        case 1:
            return "Enviado/Recibido";

        case 2:
            return "Registrado por T.H.";

        case 3:
            return "Negado";

        case 6:
            return "Notificado/Negado por servidor";

        default:
            return "";
    }
}
export class DocumentosEntregar extends React.Component<RouteComponentProps<{}>, DocumentosEntregarState>{
    iconForDocument = classNameDownloadPdf;
    constructor(props) {
        super(props);

        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, isOpenModal: false, urlPDF: "", disableBtn: true,
            avisoEntradaData: new AvisoEntradaData(), filesData: [],
            showModalDocumentoAvisoEntrada: false,
            mensajeInformacion: undefined,
            modalNotificarInconveniente: {
                show: false,
                siglasDocumento: ""
            }
        };

        this.cargarSolicitudIngreso = this.cargarSolicitudIngreso.bind(this);
        this.handleModalChange = this.handleModalChange.bind(this);
        this.handleChange = this.handleChange.bind(this);        
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.HandleSubirDocumentoAvisoEntrada = this.HandleSubirDocumentoAvisoEntrada.bind(this);
        this.EvaluateReg = this.EvaluateReg.bind(this);
        this.RegistroFilaDocumentoEntradaIEES = this.RegistroFilaDocumentoEntradaIEES.bind(this);        
        this.ShowInformacionDocumento = this.ShowInformacionDocumento.bind(this)
        this.NotificarInconvenienteDocumento = this.NotificarInconvenienteDocumento.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    if (this.state.currentUser.esespol !== "No") {
                        this.cargarSolicitudIngreso();
                    }
                }
            }
        );
        const $style = document.createElement("style");
        document.head.appendChild($style);
        $style.innerHTML = ".wrapper {height: auto;}";
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarSolicitudIngreso() {

        var url = new URL(API_URL + "SolicitudIngreso/PersonaId/" + this.state.currentUser.idpersona);      

        fetch(url.href)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (result.entTabla[0]) {

                            var dto: AvisoEntradaData = {
                                ...result.entTabla[0],
                                fechaDocumento: result.entTabla[0].fechadocumento // Ensure correct mapping
                            };
                            var disableBtn = false;

                            if ((dto.refdoc3 == null && dto.refdoc == null)) {
                                disableBtn = true;
                            }

                            this.setState({
                                avisoEntradaData: dto,
                                disableBtn: disableBtn,
                            });
                        }
                        else {
                            this.setState({
                                avisoEntradaData: new AvisoEntradaData()
                            });
                        }

                    } else {
                        alertService.error("Ocurrió un error al obtener los datos de la persona.")
                    }
                    this.setState({
                        loading: false,
                    });
                },
                (error) => {
                    this.setState({
                        avisoEntradaData: new AvisoEntradaData()
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
            .catch((error) => {
                alertService.error(error)
            }
            );
    }

    handleModalChange() {
        this.setState({ isOpenModal: !this.state.isOpenModal });
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        var dto = this.state.avisoEntradaData;
        dto[event.target.name] = event.target.value;

        this.setState({
            avisoEntradaData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.avisoEntradaData;
        dto[name] = value;
        var parseValue: string | Date;
        if (name === "fechaDocumento") {
            parseValue = value
            dto[name] = parseValue;
        }

        this.setState({ avisoEntradaData: dto });
    }

    vistaPrevia(tipo) {
        let url = API_URL + "SolicitudIngreso/RefDocumentoAvisoEntrada/" + tipo + "/" + this.state.avisoEntradaData.idotrosdocumentos
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    this.setState({ urlPDF: url, isOpenModal: true });
                });
            });
    }

    NotificarInconvenienteDocumento = async (observacion: string, siglasDocumento: string, idOtrosDocumentos: number) => {
        try {
            const notificacionPost: PostNotificarInconvenienteDTO = {
                descripcion: observacion,
                idOtrosDocumentos: idOtrosDocumentos,
                tipoDocumento: siglasDocumento
            }
            const URL_SERVER = configData.SERVER_URL;
            const URL_NOTIFICACION = "SolicitudIngreso/NotificarInconvenienteDocumento";
            const respuesta = await axios.post(URL_SERVER + URL_NOTIFICACION, notificacionPost,
                {
                    headers: authHeader()
                }
            );
            if (respuesta.status === 200) {
                alertService.success("Su notificación ha sido enviada a la Dirección de Talento Humano")
            } else {
                alertService.error("No ha sido posible notificar sobre su inconveniente")
            }

            this.setState({
                modalNotificarInconveniente: {
                    show: false,
                    siglasDocumento: ""
                }
            })
        } catch (error) {
            const respuesta = await hadleAxiosErrorResponse(error);
            return -1;
        }
        return -1;
    }    

    public EvaluateReg(texto: string | null) {
        if (texto) {
            const expresion = new RegExp("^[\S]{8}$", "gi");
            var r = expresion.test(texto);
            return r !== null
        }
        return false
    }

    public render() {
        let contents = this.state.loading
            ?
            <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>
            : this.renderForm();

        return <div className="content">
            {contents}
        </div>;
    }

    ShowInformacionDocumento = (tipoDocumento: string) => {
        var mensaje: React.ReactElement = <></>;

        if (tipoDocumento === "AE") {
            mensaje = (
                <span className="text-justify">
                    Debe descargar el documento, firmar electrónicamente el aviso de entrada y subirlo. De no poseer firma electrónica podrá firmarlo manualmente y entregar el original en las oficinas de la DTH, para hacer efectivo su proceso.
                </span>
            )
        }

        this.setState({ mensajeInformacion: mensaje })
    }

    BotonInformacion = (tipoDocumento: string) => {
        return (
            <div className="containerAvisoEntrada">
            <i
                className="fas fa-info-circle pr-2 infoIcon"
                aria-hidden="true"
                    style={{ color: "orange" }}
                onClick={() => this.ShowInformacionDocumento(tipoDocumento)}
                data-toggle="tooltip" data-placement="top" title="Información del documento"
                />
            </div>
        )
    }   

    IconoNotificar = (idIcono: string, tipoDocumento: string, disabled: boolean, className?: string) => {

        var classNameAdicional = "";
        if (disabled) {
            classNameAdicional = "iconMessageDisabled"
        }

        return (
            <div className="containerAvisoEntrada">
            <i
                className={classNameIconoMessage + " " + (className ?? "") + " " + classNameAdicional}
                id={idIcono}
                onClick={() => this.setState({
                    modalNotificarInconveniente: {
                        show: true,
                        siglasDocumento: tipoDocumento
                    }
                })}
                data-toggle="tooltip" data-placement="top" title="Notificar inconveniente"
                />
            </div>
        )
    }

    RegistroFilaDocumentoEntradaIEES = (solicitudIngresoData: AvisoEntradaData) => {
        const extraData: ExtraInfoAvisoEntrada = {
            refdocumentoBase: solicitudIngresoData.refarchivo2,
            refdocumentoAEFirmaServidor: solicitudIngresoData.refdoc3,
            refdocumentoAEFirmaTotal: solicitudIngresoData.refdoc,
            idPersonaFinancieroFirma: solicitudIngresoData.idusuarioultodc ?? 0
        }

        var fechaDocumento = solicitudIngresoData.fechaDocumento;

        const disabledNotificar = solicitudIngresoData.estadorevisionth === EstadoRevisionTH.NOTIFICADO_SERVIDOR;

        const estadosDontShowNotificar: number[] = [EstadoRevisionTH.ENVIADO_UATH, EstadoRevisionTH.APROBADO, EstadoRevisionTH.NEGADO, EstadoRevisionTH.ENVIADO_GERENCIA_FINANCIERA, EstadoRevisionTH.NOTIFICADO_SERVIDOR];

        const dontShowNotificar = (estadosDontShowNotificar.includes(solicitudIngresoData.estadorevisionth))

        const disabledDownloadArchivoTH = solicitudIngresoData.refdoc3 === undefined || solicitudIngresoData.refdoc3 === null

        return (
            solicitudIngresoData.idotrosdocumentos !== 0 ?
            <tr key={"documentoEntradaIEES"}>
                <td>
                    <span>Aviso de Entrada </span>
                </td>
                <td>
                    {this.BotonInformacion("AE")}
                </td>
                <td colSpan={1} className='text-center'>
                    <Label className="bold">
                        {fechaDocumento ? formatoFecha(fechaDocumento.toString()) : "Fecha de emisión"}
                    </Label>
                </td>
                <td colSpan={2} className='text-left'>
                    <div className="container-button-documentos">
                        <DownloadIcon
                            src={API_URL + `Files/GetArchivoVistaPrevia/refArchivo/${this.state.avisoEntradaData.refarchivo2}`}
                            showTooltips={true}
                            titleTooltips={"Documento Aviso Entrada IESS sin firma"}
                            id={"downloadDoc1"}
                            placeholder={"Descargar Aviso de Entrada"}
                            fetchFromApi={true}
                            disabled={this.state.avisoEntradaData.refarchivo2 === undefined || this.state.avisoEntradaData.refarchivo2 === null || solicitudIngresoData.estadorevisionth === EstadoRevisionTH.APROBADO || solicitudIngresoData.estadorevisionth === EstadoRevisionTH.ENVIADO_GERENCIA_FINANCIERA}
                            name='Aviso de entrada sin firma.pdf'
                            className='flex-child-button-documentos'
                        />
                        {
                            (!dontShowNotificar) &&
                            <Button
                                className='btn-no-float flex-child-button-documentos'
                                disabled={(this.state.avisoEntradaData.refdoc !== null && solicitudIngresoData.estadorevisionth === 2) || solicitudIngresoData.idusuarioultodc !== null || solicitudIngresoData.estadorevisionth === EstadoRevisionTH.ENVIADO_GERENCIA_FINANCIERA || solicitudIngresoData.refarchivo2 === null}
                                onClick={() => this.setState({ showModalDocumentoAvisoEntrada: true })}
                            > Subir documento firmado en firma de afiliado </Button>
                        }
                    </div>
                </td>                
                <td className='text-center'>
                    <InputFileDownload
                        tipo="Aviso de Entrada Firmado"
                        id="downloadDocAEFirmado"
                        refarchivo={this.state.avisoEntradaData.refdoc3}
                        name={`${AVISO_ENTRADA} Firmado-` + this.state.currentUser.identificacion + ".PDF"}
                        url={API_URL + `SolicitudIngreso/RefDocumentoAvisoEntrada/${AVISO_ENTRADA}/` + this.state.avisoEntradaData.idotrosdocumentos}
                        icon={this.iconForDocument}
                        disabled={disabledNotificar}
                    />
                </td>
                <td>
                    {ParseEstadosDocumentosTH(solicitudIngresoData.estadorevisionth, extraData)}
                </td>
                <td>
                    {(!dontShowNotificar) && this.IconoNotificar("iconoNotificarInconvenienteAE", "AE", disabledNotificar, "iconNotificarDocumento")}
                </td>
            </tr>
                :
            <></>
        )
    }

    HandleClickNotificar(siglasDocumento: string) {
        this.setState({
            modalNotificarInconveniente: {
                show: true,
                siglasDocumento
            }
        })
    }

    private async HandleSubirDocumentoAvisoEntrada(objeto: ObjetoSubirDocumento) {
        const { filesEnviar, tipoFirma, extraData } = objeto;

        if (filesEnviar.length > 0) {
            var formFilesData = new FormData();

            try {
                filesEnviar.map((fileData) => {
                    formFilesData.append("files", fileData.file, fileData.file.name);
                })
                formFilesData.append('idSolicitudIngreso', extraData.idSolicitudIngreso);
                formFilesData.append('tipoDocumento', extraData.tipoDoc);
                formFilesData.append('tipoFirma', tipoFirma);
                formFilesData.append('etapa', "SERVIDOR");
                const URL = configData.SERVER_URL + "FormularioController/PostFileDocumentoAvisoEntrada"
                const respuesta = await axios.post(URL, formFilesData, {
                    headers: authHeader()
                })
                alertService.success("Su archivo fue guardado éxitosamente y enviado al Representante Legal")
            } catch (error) {
                const mensajeError = hadleAxiosError(error);
                alertService.error(mensajeError);
            }

            this.setState({ showModalDocumentoAvisoEntrada: false })
            this.cargarSolicitudIngreso();
        }
    }

    private renderForm() {                
        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">DOCUMENTOS A ENTREGAR, HABILITANTES PARA LA VINCULACIÓN</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form autoComplete={"off"}>
                                        <Table id="documentosTable" className="tablesReact" striped>
                                            <thead>
                                                <tr>
                                                    <th >Documentos</th>
                                                    <th>Referencia</th>
                                                    <th >Fecha del documento</th>
                                                    <th colSpan={2}>Acciones</th>
                                                    <th>Descargar</th>
                                                    <th>Estado</th>
                                                    <th>Notificar inconveniente</th>
                                                </tr>
                                            </thead>
                                            <tbody>                                                
                                                {
                                                    this.RegistroFilaDocumentoEntradaIEES(this.state.avisoEntradaData)
                                                }                                                
                                            </tbody>
                                        </Table>
                                        
                                        <ModalPDF
                                            url={this.state.urlPDF}
                                            isOpen={this.state.isOpenModal}
                                            onAcept={this.handleModalChange}
                                            onCancel={this.handleModalChange}
                                            tipo="DOC"
                                        />

                                        <ModalSubirDocumentoFirmado
                                            show={this.state.showModalDocumentoAvisoEntrada}
                                            admiteFirmaFisica={true}
                                            cargandoDatos={false}
                                            size='lg'
                                            tituloModal='Subir Documento de Aviso de Entrada'
                                            onClose={() => { this.setState({ showModalDocumentoAvisoEntrada: false }) }}
                                            onClickFirmaFisica={(objeto: ObjetoSubirDocumento) => this.HandleSubirDocumentoAvisoEntrada(objeto)}
                                            onClickSubirDocFirmaElectronica={(objeto: ObjetoSubirDocumento) => this.HandleSubirDocumentoAvisoEntrada(objeto)}
                                            extraData={{ "tipoDoc": "AE", "idSolicitudIngreso": this.state.avisoEntradaData.idotrosdocumentos }}
                                        />

                                        <ModalMensaje
                                            show={this.state.mensajeInformacion !== undefined}
                                            centered={false}
                                            mensaje={""}
                                            mensajeHtml={this.state.mensajeInformacion}
                                            size={"lg"}
                                            tituloModal='Referencia'
                                            onClose={() => this.setState({ mensajeInformacion: undefined })}
                                        />

                                        <ModalIngresarObservacion
                                            show={this.state.modalNotificarInconveniente.show}
                                            // show={true}
                                            centered={true}
                                            size='xl'
                                            tituloModal='Notificar Observación a Dirección de TH'
                                            onClose={() => this.setState({
                                                modalNotificarInconveniente: {
                                                    show: false,
                                                    siglasDocumento: ""
                                                }
                                            })}
                                            mensajeHtml={<div></div>}
                                            asyncOnClick={(observacion: string) => this.NotificarInconvenienteDocumento(observacion, this.state.modalNotificarInconveniente.siglasDocumento, this.state.avisoEntradaData.idotrosdocumentos)}
                                        />
                                    </form >
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>
        );
    }
}
export default DocumentosEntregar;